import {AdminAddSponsorForm} from './AdminAddSponsorForm';

export default AdminAddSponsorForm;
